import "./init.js";
import "./index.css";
import { StrictMode } from "react";
import Chat from "./Chat";
import { init as initLocalization } from "@/lib/localization";
import * as Sentry from "@sentry/react";
import ChatConfig from "@microsoft/omnichannel-chat-sdk/lib/core/ChatConfig.js";
import { dynamicConfig, activeWidgetConf_set, activeWidgetConf_get } from "./preLoadState.js";
import ChatSDKConfig from "@microsoft/omnichannel-chat-sdk/lib/core/ChatSDKConfig.js";
import { OmnichannelChatSDK } from "@microsoft/omnichannel-chat-sdk";
import { WidgetConfig } from "./preLoadState.js";
// Add event listener for widget load
window.addEventListener(
    "load",
    () => {
        run();
    },
    { once: true },
);

// NOTE: (see vite.config.js)
//  - we're dropping `console.*` and `debugger` statements in prod
//  - import.meta.env is a Vite feature
//    - import.meta.env.DEV  |> true on dev
//    - import.meta.env.PROD  |> true on prod
async function run() {
    console.time("full init");
    const IMPORT_OmnichannelChatSDK = import("@microsoft/omnichannel-chat-sdk")
    const IMPORT_createRoot = import("react-dom/client")

    // Initialize localization
    console.time("initialize localization");
    initLocalization();
    console.timeEnd("initialize localization");


    // check for mounting point
    const root = document.getElementById("dpj_widget");
    if (!root) {
        throw new Error("No root element found");
    }
    // Load config and initialize chat SDK
    console.time("load dynamic config");
    const { omni, chat, chatTopLinks, proactives } = await dynamicConfig();
    console.timeEnd("load dynamic config");

    console.time("initialize chat sdk");
    let done = false
    let { sdk, oooh, show } = { sdk: null as null | OmnichannelChatSDK, oooh: false, show: false }

    // Run tests consecutively instead of concurrently
    const runConfigsSequentially = async () => {
        for (const oc of omni) {
            if (done) break
            ({ sdk, oooh, show } = await runWithConfig(oc, chat))
            if (sdk && show && !oooh) {
                done = true
                activeWidgetConf_set(oc)
            }
        }
    }

    // Start the sequential execution
    await runConfigsSequentially()
    console.timeEnd("initialize chat sdk");
    if (!done || !sdk) {
        console.error("Failed to initialize chat sdk");
        activeWidgetConf_set(null)
        return;
    }
    const activeConfigName = activeWidgetConf_get()?.name ?? null

    // all conditions are met, render the widget
    console.time("render chat");
    const { createRoot } = await IMPORT_createRoot
    createRoot(root).render(
        <StrictMode>
            <Sentry.ErrorBoundary fallback={<></>}>
                <Chat chatSDK={sdk} initialData={{ chatTopLinks, proactives, widgetConfName: activeConfigName }} />
            </Sentry.ErrorBoundary>
        </StrictMode>,
    );
    console.timeEnd("render chat");
    console.timeEnd("full init");



    async function runWithConfig(occ: WidgetConfig, sdkc?: ChatSDKConfig): Promise<{ sdk: null | OmnichannelChatSDK, oooh: boolean, show: boolean }> {
        console.log("runWithConfig", { occ, sdkc })
        const { OmnichannelChatSDK } = await IMPORT_OmnichannelChatSDK
        const sdk = new OmnichannelChatSDK(occ, sdkc)
        // @ts-expect-error unsused undefined variable
        DEV: window.ocSdk = sdk;
        return sdk.initialize({
            useParallelLoad: true,
        })
            .then(async (chatConfig: ChatConfig) => {
                const res = {
                    sdk,
                    oooh: chatConfig.LiveWSAndLiveChatEngJoin.OutOfOperatingHours === "True",
                    show: chatConfig.LiveWSAndLiveChatEngJoin.ShowWidget === "True",
                    name: occ.name
                }
                console.log("sdk initialized", res)
                return res
            }).catch((error) => {
                console.error("initialize error", error);
                Sentry.captureException(error);
                return { sdk: null, oooh: false, show: false }
            });
    }
}
